export default __webpack_public_path__ + "media/img/play_white-cb7768adc0be423ce2c95bb537e5d639.svg";